import {
    combineReducers,
    configureStore,
    ConfigureStoreOptions,
} from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import auth from 'app/core/slices/auth/auth.slice'
import { api } from 'app/core/services/base/api.service'
import joinProduct from 'app/core/slices/product/joinProduct.slice'
import productDetail from 'app/core/slices/product/productDetail.slice'
import comboProductList from 'app/core/slices/product/comboProductList.slice'
import comboProduct from 'app/core/slices/product/comboProduct.slice'
import excUserInfo from 'app/core/slices/fns/frx/frx.slice'
import lonGetMortgageAgreement from 'app/core/slices/doc/lonGetMortgageAgreement.slice'
import getResidentAgreement from 'app/core/slices/doc/getResidentAgreement.slice'
import issueCardInfo from 'app/core/slices/product/issueCardInfoslice.slice'
import IssueCardPreInqInfo from 'app/core/slices/product/IssueCardPreInqInfo.slice'
import elecFinanceInfo from 'app/core/slices/fns/sbk/sbkslice'
import bridgeCombo from './slices/com/bridgeCombo.slice'
import user from 'app/core/slices/user/user.slice'
import mobileAuth from 'app/core/slices/user/mobileAuth.slice'
import bankingInfo from 'app/core/slices/user/bankingInfo.slice'
import continuable from 'app/core/slices/user/continuable.slice'
import menu from 'app/core/slices/user/menu.slice'
import trnsKeyInfo from 'app/core/slices/com/trnsKeyInfo.slice'
import banners from 'app/core/slices/com/banner.slice'
import terms from 'app/core/slices/com/terms.slice'
import productMain from 'app/core/slices/product/productMain.slice'
import facInfo from 'app/core/slices/com/facInfo.slice'
import tgrMain from 'app/core/slices/tgr/tgrMain.slice'

import logger from 'redux-logger'
import storage from 'redux-persist/lib/storage'
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: [
        'productDetail',
        'excUserInfo',
        'joinProduct',
        'elecFinanceInfo',
        'comboProduct',
        'comboProductList',
        'lonGetMortgageAgreement',
        'getResidentAgreement',
        'issueCardInfo',
        'IssueCardPreInqInfo',
        'bridgeCombo',
        'user',
        'mobileAuth',
        'bankingInfo',
        'continuable',
        'menu',
        'trnsKeyInfo',
        'banners',
        'terms',
        'productMain',
        'facInfo',
        'tgrMain',
    ],
}

const reducer = {
    [api.reducerPath]: api.reducer,
    auth,
    joinProduct,
    productDetail,
    comboProduct,
    comboProductList,
    excUserInfo,
    elecFinanceInfo,
    lonGetMortgageAgreement,
    getResidentAgreement,
    issueCardInfo,
    IssueCardPreInqInfo,
    bridgeCombo,
    user,
    mobileAuth,
    bankingInfo,
    continuable,
    trnsKeyInfo,
    menu,
    banners,
    terms,
    productMain,
    facInfo,
    tgrMain,
}

const rootReducer = combineReducers(reducer)
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const createStore = (
    options?: ConfigureStoreOptions['preloadedState'] | undefined
) =>
    configureStore({
        reducer: persistedReducer, //reducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [
                        FLUSH,
                        REHYDRATE,
                        PAUSE,
                        PERSIST,
                        PURGE,
                        REGISTER,
                    ],
                },
            })
                .concat(api.middleware)
                .concat(logger),
        ...options,
    })

export const store = createStore()
export const persistor = persistStore(store)

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
